import tableConfig from '@/views/pages/tableConfig'

export default function config(isInbox, moduleName) {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'subject', label: 'Subject', sortable: true },
    { key: 'body', label: 'Body', sortable: true },
    { key: 'file', label: 'File' },
    { key: isInbox ? 'is_read' : 'isSend', label: 'Status' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig(moduleName),
  }
}
